export const isUsingIE =
    window.navigator.userAgent.indexOf('MSIE ') > 0 || Boolean(navigator.userAgent.match(/Trident.*rv\\:11\./))
